
import './Contact.css';
import NewDynamicBackground from '../components/NewDynamicBackground'; // import background

function Contact() {


  return (
              <>
    <NewDynamicBackground variant={5}/>
    <div className="contact-wrapper">

      <h2 className="contact-title">Contact</h2>

      <p className="contact-intro">
        I welcome collaboration, discussion, and inquiries about my research in HCI, health, and design. 
        Please feel free to reach out via email.
      </p>

      <div className="contact-info">
        <p><strong>Email:</strong> <a href="mailto:b.yu@hva.nl">b.yu@hva.nl</a></p>
        <p><strong>Office:</strong> Room 06A02, Wibauthuis, Wibautstraat 3-b, 1091GH Amsterdam
        </p>
        <p>
          <strong>Profiles:</strong> 
          <a href="https://scholar.google.nl/citations?user=uhdNK1EAAAAJ&hl=en" target="_blank" rel="noreferrer">Google Scholar</a> | 
          <a href="https://www.researchgate.net/profile/Bin-Yu-14?ev=hdr_xprf" target="_blank" rel="noreferrer">ResearchGate</a> | 
          <a href="https://www.linkedin.com/in/bin-yu-85935450/" target="_blank" rel="noreferrer">LinkedIn</a>
        </p>
      </div>

    </div>
    </>
  );
    
}

export default Contact;
